/**
 * @generated SignedSource<<b653acff67ebd816c30d05f95f8a8bbd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "RolePermissions_activePermission",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Permission",
  "abstractKey": null
};

node.hash = "26c2e6b9c51afd195f350b43ff8770a3";

export default node;
